module.exports = __webpack_public_path__ + "img/RGM.02defc2c.png";